import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';

// ngUpgrade Angular core services module
// Import converted service classes in ./services here
// Add to providers array, below
// Then go back to core.services.module.ajs.ts and register the downgraded service
import { TrackerRest } from './tracker.rest';
import { TrackerService } from './tracker.service';
import { TrackerQueryService } from './tracker.query.service';
import { TrackeritemRest } from './trackeritem.rest';
import { TrackeritemService } from './trackeritem.service';
import { TrackeritemBreakdownService } from './trackeritem.breakdown.service';
import { KanbanStrategyService } from './kanban.strategy.service';
import { TrackerFilterService } from './tracker.filter.service';
import { TrackeritemQueueService } from './trackeritem.queue.service';
import { TrackerItemValidationService } from './trackeritem.validation.service';
import { TrackerResolvesService } from '../tracker-resolves.service';

@NgModule({
    imports: [
        BrowserModule,
        HttpClientModule
    ],
    providers: [
        TrackerRest,
        TrackerService,
        TrackeritemRest,
        TrackeritemService,
        TrackeritemBreakdownService,
        TrackerQueryService,
        KanbanStrategyService,
        TrackerFilterService,
        TrackeritemQueueService,
        TrackerItemValidationService,
        TrackerResolvesService
    ]
})
export class TrackerServicesModule {
    constructor() { }
}